/**
 * The Faye travel insurance launch flag, browser side.
 *
 * Off (the default) until launch: the Help Center, the checkout FAQ and
 * acknowledgments, and the Terms of Service all read exactly as they did
 * before Faye. Turn it on with `VITE_FAYE_INSURANCE_ENABLED=true` (exactly
 * that string), together with the server's `FAYE_INSURANCE_ENABLED=true`
 * (server/faye-flag.js) so the concierge desk and the pages agree.
 *
 * LEGAL REVIEW BEFORE LAUNCH: the Terms section and the acknowledgment
 * carve-outs behind this flag are drafts. Legal must review them, and Faye
 * must approve all copy about its plans, before the flag is turned on.
 *
 * Vite inlines the value at build time, so flipping the flag means a rebuild.
 */
function readFlag() {
  try {
    // Static member access on purpose: Vite replaces it with a literal (as
    // with VITE_APPLE_PAY_ENABLED), so the bundle never carries an env object.
    return import.meta.env.VITE_FAYE_INSURANCE_ENABLED === 'true';
  } catch {
    // Plain Node, outside Vite: there is no import.meta.env, so it's off.
    return false;
  }
}

export const FAYE_INSURANCE_ENABLED = readFlag();
